import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
   Select,
    FormControl, InputLabel,
  Box, 
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Swal from "sweetalert2";
import { useAuth } from "../../../AuthProvider";
import { Download } from "lucide-react";
import { ListItemIcon, Menu, MenuItem,ListItemText} from "@mui/material"; 
import { InsertDriveFile, PictureAsPdf, Code } from "@mui/icons-material"; 

import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';


const baseUrl = process.env.REACT_APP_API_BASE_URL;

function SchedulingRouteList() {
  const [loading, setLoading] = useState(true);
  const { oId,role,pId,userId } = useAuth();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const [busRoutes, setBusRoutes] = useState([]);
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading


    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const isExportMenuOpen = Boolean(exportAnchorEl);
    
    const handleExportClick = (event) => {
      setExportAnchorEl(event.currentTarget);
    };
    
    const handleExportClose = () => {
      setExportAnchorEl(null);
    };
    // const handleClose = () => {
    //   setExportAnchorEl(null);
    // };

  const navigate = useNavigate();

  const handleAddNew = () => {
    navigate("/BusScheduleRouteForm");
  };


  const [users, setUsers] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState('');
    const isPrincipal = role?.startsWith("PRINCIPAL") || false;
    const UserId = userId || selectedUsers;

  
       const fetchUsers = async () => {
           try {
               const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/TRANSPORT/${oId}/${pId}`);
               if (!response.ok) {
                   throw new Error('Failed to fetch users');
               }
               const data = await response.json();
               setUsers(data);
               if (data.length > 0) {
                 setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
             }
           } catch (error) {
               console.error('Error fetching users:', error);
           }
       };
    useEffect(() => {
    if (isPrincipal) {
        fetchUsers();
    }
}, []);


  const getBusRoutes = async () => {
    if(!UserId) return;
    try {
      const response = await fetch(
        `${baseUrl}/api/SchedulingRoute/getAll/${oId}/${UserId}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setFilteredData(data);
    } catch (error) {
      console.error("Error fetching bus routes:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBusRoutes();
  }, [UserId]);

   // Filter data based on searchQuery
   const filteredResults = filteredData.filter((item) => {
    const busNo = item.busNumberPlate ? item.busNumberPlate.toString().toLowerCase() : "";
    const routeNo = item.routeNumber ? item.routeNumber.toString().toLowerCase() : "";
    
    return (
      busNo.includes(searchQuery.toLowerCase()) || 
      routeNo.includes(searchQuery.toLowerCase())
    );
  });
  

  const handleEditClick = (row) => {
    setSelectedRow(row); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };

 const handleDeleteClick = async (row) => {
    if (!row.id) {
      toast.error("Invalid row. Please select a valid row to delete.");
      return;
    }
  
    // Show SweetAlert2 confirmation
    Swal.fire({
      title: "Are you sure?",
      text: `You want To Delete ${row.busNumber}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          console.log("Deleting row with ID:", row.id);
          const response = await fetch(
            `${baseUrl}/api/SchedulingRoute/delete/${row.id}/${oId}/${pId}`,
            {
              method: "DELETE",
            }
          );
  
          if (!response.ok) {
            throw new Error(" Failed to delete the Bus. Because Driver or Student Already Registered For This Bus.");
          }
  
          toast.success(`${row.busNumber} Deleted Successfully!`, {
            autoClose: 1000, // Closes after 1 second (1000ms)
          });
          
          getBusRoutes();
          // // Remove the row from state after successful deletion
          // setFilteredData((prevData) =>
          //   prevData.filter((row) => row.id !== row.id)
          // );
  
         
        } catch (error) {
          console.error("Error deleting row:", error);
          toast.error(`Error deleting row: ${error.message}`);
        }
      }
    });
  };

  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };

  const handleSaveChanges = async () => {
    if (!selectedRow || !selectedRow.id) {
      toast.error("Invalid selection. Please select a valid row.");
      return;
    }
    setDialogbtnloading(true); // Start loading
    try {
      const formData = new FormData();

      // Append each key-value pair to FormData
      Object.keys(selectedRow).forEach((key) => {
        if (selectedRow[key] !== null && selectedRow[key] !== undefined) {
          formData.append(key, selectedRow[key]);
        }
      });

     
      const response = await fetch(
        `${baseUrl}/api/SchedulingRoute/update/${selectedRow.id}/${oId}`,
        {
          method: "PATCH", // Use PATCH for partial updates
          body: formData, // Send FormData instead of JSON
        }
      );

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(
          responseData.message || "Failed to update the details."
        );
      }

      console.log("Update successful:", responseData);
      toast.success("Details updated successfully!");
      getBusRoutes();

      handleDialogClose(); // Close the dialog after successful update
    } catch (error) {
      console.error("Error updating details:", error);
      toast.error(`Error updating details: ${error.message}`);
    } finally {
      setDialogbtnloading(false); // Stop loading
    }
  };


  // Downloadbutton


  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };


  // const handleClose = async (format) => {
  //   setAnchorEl(null);
  //   if (!format) return;

  //   try {
  //     const response = await axios.get(`${baseUrl}/api/SchedulingRoute/getAll/${oId}`);
  //     let data = response.data;
  //     if (!data || data.length === 0) throw new Error("No data received from API");

  //      // Remove "id" column and add S. No (starting from the left)
  //      data = data.map(({ id, ...rest }, index) => ({ "S. No": index + 1, ...rest }));

  //      downloadFile(data, format);
  //    } catch (error) {
  //      console.error("Error fetching data:", error);
  //      alert("Failed to fetch data!");
  //    }
  //  };
 
 
 // Export to Excel
const exportToExcel = () => {
  const filteredData = filteredResults.map(
    ({ busNumber, busNumberPlate, routeNumber, route, busPickupLocation, stops, busDropLocation }) => {
      // Split stops into chunks of 3 and add line breaks
      const stopsArray = stops.split(",");
      const chunkedStops = [];
      for (let i = 0; i < stopsArray.length; i += 3) {
        chunkedStops.push(stopsArray.slice(i, i + 3).join(","));
      }
      const formattedStops = chunkedStops.join("\n");

      return {
        BusNumberPlate: busNumberPlate,
        RouteNumber: routeNumber,
        Route: route,
        BusPicUpLocation: busPickupLocation,
        Stops: formattedStops,
        BusDropLocation: busDropLocation,
      };
    }
  );

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Bus_Schedule_Route_List");

  // Add headers
  worksheet.columns = [
    { header: "Bus No Plate", key: "BusNumberPlate", width: 25 },
    { header: "Route No", key: "RouteNumber", width: 25 },
    { header: "Route", key: "Route", width: 25 },
    { header: "Bus PicUpLocation", key: "BusPicUpLocation", width: 25 },
    { header: "Stops", key: "Stops", width: 40 },
    { header: "Bus DropLocation", key: "BusDropLocation", width: 25 },
  ];

  // Add data rows
  filteredData.forEach((data) => {
    worksheet.addRow(data);
  });

  // ✅ Center & wrap text for all rows under each header
  worksheet.eachRow((row, rowNumber) => {
    row.eachCell((cell) => {
      cell.alignment = {
        horizontal: "center", // center horizontally
        vertical: "middle",   // center vertically
        wrapText: true        // allow multi-line text
      };
    });
  });

  // Style headers separately (they’re already bold/center)
  worksheet.getRow(1).eachCell((cell) => {
    cell.font = { bold: true };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "87CEEB" },
    };
  });

  // Write and download file
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Bus_Schedule_Route_List.xlsx`;
    link.click();
  });

  handleExportClose();
};


 
 // Export to PDF
const exportToPDF = () => {
  const doc = new jsPDF();

  // Title
  doc.setFontSize(16);
  doc.setFont("helvetica", "bold");
  doc.text("Bus Schedule Route List", 10, 10);

  // Date
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Generated On: ", 10, 18);
  doc.setFont("helvetica", "bold");
  doc.text(new Date().toLocaleDateString(), 37, 18);

  // Build table body with formatted stops
  const body = filteredResults.map((row, index) => {
    const stopsArray = row.stops.split(",");
    const chunkedStops = [];
    for (let i = 0; i < stopsArray.length; i += 3) {
      chunkedStops.push(stopsArray.slice(i, i + 3).join(","));
    }
    const formattedStops = chunkedStops.join("\n");
    return [
      index + 1,
      row.busNumberPlate,
      row.routeNumber,
      row.route,
      row.busPickupLocation,
      formattedStops,
      row.busDropLocation,
    ];
  });

  // Table
  doc.autoTable({
    startY: 25,
    head: [
      ["S.No", "Bus No", "Route No", "Route", "Bus PicUpLocation", "Stops", "Bus DropLocation"]
    ],
    body: body,
    styles: {
      lineWidth: 0.2,
      lineColor: "#B6B9CD",
      fontSize: 10,
      cellPadding: 3,
      halign: "center",
      valign: "middle",
    },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: [255, 255, 255],
      halign: "center",
      valign: "middle",
    },
    bodyStyles: {
      halign: "center",
      valign: "middle",
    },
    columnStyles: {
      0: { cellWidth: 15 }, // S.No
      1: { cellWidth: 25 }, // Bus No
      5: { cellWidth: 50 }, // Stops
    },
    theme: "grid",

    // ⬇️ NEW: control left/right margins
    margin: { top: 25, left: 5, right: 5 }, // reduce margins
    tableWidth: 'auto', // let it auto-size to fill available space
  });

  doc.save("Bus_Schedule_Route_List.pdf");
  handleExportClose();
};

 


 
 
 // Export to JSON
 const exportToJSON = () => {
   const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
     JSON.stringify(filteredResults, null, 2)
   )}`;
   const link = document.createElement("a");
   link.href = jsonString;
   link.download = "Bus_Schedule_Route_List.json";
   link.click();
   handleExportClose();
 };
 
 

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <CardContent
      // style={{
      //   width: "950px",
      //   margin: "auto",
      // }}
      >
        {/* Title Section */}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography
              variant="h4"
              style={{ fontWeight: "bold", color: "#333" }}
            >
              Scheduled Bus Routes
            </Typography>
          </Grid>
        </Grid>

        {/* Search and Add New Button Section */}
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ marginTop: "1px" }}
        >
          <Grid item xs={3}>
            <TextField
              fullWidth
              label="Search by Bus No Or Route No"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Grid>

          {/* {isPrincipal && (
              <Grid item xs={6} >
                <FormControl fullWidth size="small" style={{ width: "200px" }}>
                  <InputLabel>Select Transport Admin</InputLabel>
                  <Select
                    value={selectedUsers}
                    onChange={(e) => setSelectedUsers(e.target.value)}
                    label="Select Transport Admin"
                  >
                    {users.map((user) => (
                      <MenuItem key={user.userId} value={user.userId}>
                        {user.userId} - {user.firstName} {user.lastName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )} */}

          <Grid item xs={3} display="flex" justifyContent="flex-end" gap={2}>
          
          <Button 
    variant="contained" 
    onClick={handleExportClick}  
    style={{ backgroundColor: '#3C3972', fontWeight: 'bold' }}
    startIcon={<PresentToAllIcon />}  
  >
    Export
  </Button>

  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem 
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#00796b' }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#d32f2f' }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
    </MenuItem>
    
    {/* <MenuItem 
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#6a1b9a' }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
    </MenuItem> */}
  </Menu>

    <Button
  variant="contained"
  onClick={handleAddNew}
  sx={{
    width: "120px", // Reduced width
    minWidth: "auto", // Prevents unnecessary expansion
    backgroundColor: "#3C3972",
    color: "#fff",
    fontWeight:'bold',
    height: "35px", // Reduced height
    fontSize: "12px", // Smaller font size
    whiteSpace: "nowrap", // Ensures text stays on one line
    "&:hover": {
      backgroundColor: "#3C3972",
    },
  }}
>
  Schedule route
</Button>

          </Grid>
        </Grid>

        <GlobalStyles
          styles={{
            ".custom-sidebar-scrollbar": {
              scrollbarWidth: "thin", // For Firefox
              scrollbarColor: "grey #e0e0e0",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar": {
              width: "6px", // For WebKit-based browsers
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
              background: "#f1f1f1", // Track color
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
              backgroundColor: "grey", // Thumb color
              borderRadius: "10px",
            },
            ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        />
        {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                
                {/* <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Bus Id
                </TableCell> */}
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold' ,
                    fontSize:'14px'
                  }}
                >
                  Bus No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold'
                     ,
                    fontSize:'14px'
                  }}
                >
                  Route No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "2px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Route
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Pickup Location
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Stops
                </TableCell>

                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Drop Location
                </TableCell>

                
                
                <TableCell
                  sx={{
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                <TableCell colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                  <Box display="flex" flexDirection="column" alignItems="center">
                    <CircularProgress />
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Loading Data...
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
              
              ) : filteredResults.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredResults.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "40px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.busNumber}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.busNumberPlate}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.routeNumber}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.route}
                    </TableCell>
                   

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.busPickupLocation}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.stops}
                    </TableCell> */}
                   <TableCell
  sx={{
    textAlign: "center",
    borderRight: "1px solid #ddd",
    padding: "2px",
    maxWidth: "200px",
    overflow: "hidden",
  }}
>
  <div
    style={{
      display: "block",
      maxHeight: "60px",
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      wordWrap: "break-word",
      whiteSpace: "normal",
    }}
  >
    {(() => {
      try {
        const stopsArray = JSON.parse(row.stops);
        if (Array.isArray(stopsArray)) {
          return stopsArray.join(", ");
        }
        return row.stops;
      } catch (e) {
        return row.stops; // fallback for invalid JSON
      }
    })()}
  </div>
</TableCell>

                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.busDropLocation}
                    </TableCell>

                   
                   
                    <TableCell sx={{ textAlign: "center", padding: "2px" }}>
                       <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "4px",
                                                  }}
                                                >
                      {/* <IconButton
                        onClick={() => handleEditClick(row)}
                        style={{ color: "blue", marginRight: "10px" }}
                      >
                        <EditIcon />
                      </IconButton> */}
                       <Button
                                                    sx={{
                                                      backgroundColor: "#1565c0",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#0d47a1" },
                                                      // borderRadius: 2,
                                                      padding: "2px 4px",
                                                    }}
                                                    onClick={() => handleEditClick(row)}
                                                  >
                                                    Edit
                                                  </Button>


                      {/* <IconButton
                        onClick={() => handleDeleteClick(row.id)}
                        style={{ color: "red" }}
                      >
                        <DeleteIcon />
                      </IconButton> */}

                      <Button
                                                     sx={{
                                                      backgroundColor: "#a82814",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#7a1b0e" },
                                                      // borderRadius: 2,
                                                      padding: "4px 6px",
                                                    }}
                                                    onClick={() => handleDeleteClick(row)}
                                                  >
                                                    Delete
                                                  </Button>
                                                  </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog for editing */}
        <Dialog open={isDialogOpen} onClose={handleDialogClose}>
          <DialogTitle style={{ fontWeight: "bold"}}>Edit Details</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label="Bus No"
                  value={selectedRow ? selectedRow.busNumberPlate : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      busNumberPlate: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                  disabled
                  InputProps={{
                    style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                  }}
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Route Number"
                  value={selectedRow ? selectedRow.routeNumber : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      routeNumber: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                  disabled
                  InputProps={{
                    style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                  }}
                />
              </Grid>
             
              <Grid item xs={6}>
                <TextField
                  label="BusPickup Location"
                  value={selectedRow ? selectedRow.busPickupLocation : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      busPickupLocation: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label=" BusDrop Location"
                  value={selectedRow ? selectedRow.busDropLocation : ""}
                  onChange={(e) =>
                    setSelectedRow((prevState) => ({
                      ...prevState,
                      busDropLocation: e.target.value,
                    }))
                  }
                  fullWidth
                  margin="normal"
                />
              </Grid>

              <Grid item xs={6}>
                <TextField
                  label="Route"
                  value={selectedRow ? selectedRow.route : ""}
                  // onChange={(e) =>
                  //   setSelectedRow((prevState) => ({
                  //     ...prevState,
                  //     route: e.target.value,
                  //   }))
                  // }
                    onChange={(e) => {
      const rawValue = e.target.value.toUpperCase();
      const sanitized = rawValue.replace(/[^-A-Z0-9_, ]/g, "");
      setSelectedRow((prevState) => ({
        ...prevState,
        route: sanitized,
      }));
    }}
                  fullWidth
                  margin="normal"
                />
              </Grid>
               <Grid item xs={6}>
                <TextField
                  label="Stops"
                  value={selectedRow ? selectedRow.stops : ""}
                  onChange={(e) => {
                      const rawValue = e.target.value.toUpperCase();
                      const sanitized = rawValue.replace(/[^-A-Z0-9_, ]/g, "");
                      setSelectedRow((prevState) => ({
                        ...prevState,
                        stops: sanitized,
                      }));
                    }}
                  fullWidth
                  margin="normal"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
          <Button
  onClick={handleDialogClose}
  color="primary"
  variant="outlined"

>
  Cancel
</Button>

<Button
  onClick={handleSaveChanges}
  color="primary"
  variant="contained"
  disabled={dialogbtnloading} // Disable when loading
  sx={{
    fontWeight: 600,
    backgroundColor: "#3C3972",
    "&:hover": { backgroundColor: "#3C3972" },
  }}
>
  {dialogbtnloading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
</Button>

          </DialogActions>
        </Dialog>
        <ToastContainer position="top-right" autoClose={1000} />
      </CardContent>
    </Card>
  );
}

export default SchedulingRouteList;